module.exports = __webpack_public_path__ + "static/media/fuyuki.2183b951.png";